import React from 'react';
import {
  Modal,
  ModalBody,
  // ModalFooter,
  ModalHeader,
} from 'reactstrap';

const ModalInfoRegisterToko = ({confirmIsOpen, confirmClose, showFaq}) => {
  console.log('confirm oepn', confirmIsOpen)
  console.log('confirm close', confirmClose)
  return (
    <Modal className="modal-message align-items-center justify-content-center force-height" size='sm' isOpen={confirmIsOpen} toggle={() => confirmClose()}>
      <ModalHeader>
      <div className="d-flex flex-column align-items-center align-items-center">
        <label className='label-header-info-toko'>Informasi penamaan toko</label>
      </div>
      </ModalHeader>
      <ModalBody className="text-left">
        <div className='row'>
          <div className="col-12 flex-column align-items-left align-items-left">
            <label className='label-body-info-toko'>Nama Toko tidak diperbolehkan mengandung:</label>
            <label className='label-body-info-toko'>- Nama Aplikasi / Instansi/ Merek tertentu</label>
            <label className='label-body-info-toko'>- Merupakan badan hukum PT/CV dan sejenisnya.</label>
            <br></br>
            <br></br>
            <label className='label-body-info-toko'>Jika usaha kamu merupakan PT/CV dan sejenisnya, pilih Hubungi Kami untuk proses pendaftaran.</label>
            <div className='row' style={{marginBottom:"30px", marginTop:"10px"}}>
            <div className="col-6 flex-column align-items-left align-items-left">
            <button className="btn btn-outline-primary btn-rounded3 pr-10" style={{width: '100%'}} onClick={() => confirmClose()}>Tutup</button>
            </div>
            <div className="col-6 flex-column align-items-left align-items-left">
            <button className="btn btn-primary btn-rounded4 pl-10" style={{width: '100%'}} onClick={() => showFaq()}>Hubungi Kami</button>
            </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ModalInfoRegisterToko
